import React from 'react';
import { withStyles } from '@material-ui/core/styles';


//drop down field
import MenuItem from 'material-ui/MenuItem';
import { ValidatorForm,SelectValidator } from 'react-material-ui-form-validator';

import Button from '@material-ui/core/Button';

//API Gateway
import {API} from "aws-amplify";

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 500,
  },
});

class UserSelect extends React.Component {
  state = {
    users:[],
    user:''

  };

    //Make GET request to get the list of user
    async componentDidMount() {
  
        try {

          const users =await this.getUser();
          this.setState({ users });

        } catch (e) {
          alert(e);
        }
      
        this.setState({ submitted: false });
      }
     // make call to API to get user for dropdown list

      getUser() {
        return API.get("userdevice", "/userdevice");
      }

  // Topics Dropdown Menu change
  handleUserFieldChange = (event, index,user) => 
  {
      this.setState({user});
      var userName = user;

      this.props.onChange(userName);
  }

  selectionRenderer = (users) => {
    switch (users.length) {
      case 0:
        return '';
      case 1:
        return users;
      default:
        return users;
    }
  }

  menuItems(users) {
    return users.map((u) => (
      <MenuItem
        key={u.id}
        insetChildren={true}
        checked={this.state.users.indexOf(u.id) > -1}
        value={u.id}
        primaryText={u.id}
      />
    ));
  }

  reset(event) {

    this.setState({  
      user:''
  });
  this.props.onChange('');  

}

  render() {

    return (
      <div>

        <ValidatorForm
                ref="form"
                onSubmit={this.handleUserFieldChange}

            >            
             <SelectValidator
                  floatingLabelText="User"
                  name= "user"
                  autoWidth={true}
                  value={this.state.user}
                  onChange={this.handleUserFieldChange}
                  selectionRenderer={this.selectionRenderer}
                  
                >
                  {this.menuItems(this.state.users.sort((a, b) => (a.user < b.user ? -1 : 1)))}
                </SelectValidator><br />
        </ValidatorForm>
        <Button size="large" color="primary" onClick={ this.reset.bind(this)} style={{marginLeft:100, marginTop:30}}>
        Reset
      </Button>
      </div>
    );
  }
}



export default withStyles(styles)(UserSelect);